import { getStorageKey } from "./localStorageStateUniqueKeyGenerator";

export function validateCardNotExpired(currentContextType) {
    // Retrieve month and year from localStorage
    const expMonthStr = localStorage.getItem(getStorageKey("ccExpMonth", currentContextType));
    const expYearStr = localStorage.getItem(getStorageKey("ccExpYear", currentContextType));
  
    // If either is missing, consider it invalid
    if (!expMonthStr || !expYearStr) {
      return false;
    }
  
    const expMonth = parseInt(expMonthStr, 10);
    const expYear = parseInt(expYearStr, 10);
  
    // Ensure month is within range
    if (isNaN(expMonth) || expMonth < 1 || expMonth > 12) {
      return false;
    }
    if (isNaN(expYear)) {
      return false;
    }
  
    // Create a date for the last day of the expiration month.
    // Here, we assume that the card expires at the end of the month.
    const expirationDate = new Date(expYear, expMonth, 0); // Day 0 returns the last day of the previous month (i.e., the correct last day of expMonth)
    const today = new Date();
  
    // Return true if today's date is before or equal to the expiration date.
    return today <= expirationDate;
  }
  